const LANG_TO_COUNTRY_MAP = {
  ja: 'jp',
  zh: 'cn',
  ko: 'kr',
  'zh-CN': 'cn', // same content that "zh", just in case amazon switches to zh.
}

export default (countryCode) => LANG_TO_COUNTRY_MAP[countryCode] || countryCode
